import styled from 'styled-components'

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;

  .swiper {
    padding: 0 40px;
    z-index: 0;
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    z-index: 10;
  }

  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
  }
`

export const NavButton = styled.button`
  background-color: #0b0c4c;
  color: white;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  width: 40px;

  span {
    font-size: 20px;
  }

  ::after {
    display: none;
  }
`

export const LogoCard = styled.div`
  background-color: white;
  border-radius: 48px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  margin-block: 16px;
`

export const LogoImage = styled.img`
  width: 120px;
  height: 60px;
  object-fit: contain;
`
